import apiClient from "./api";

export function userList() {
    return apiClient.get(`/v1/customer/profile`);
}
export function userPatch(data) {
    return apiClient.post(`/v1/customer/profile`,data,
      { 
         headers: {
            'Content-Type': 'multipart/form-data'
        }}
    );
}




